import { Button } from '@material-ui/core';
import React from 'react';

import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import { BlackHeadings, GraySmall } from 'src/theme/colors';

interface DemoPortalTransitionProps {
  onContinue: () => void;
}

export const DemoPortalTransition: React.FC<DemoPortalTransitionProps> = ({
  onContinue,
}) => {
  return (
    <div className="flex items-center justify-center h-full w-full">
      <div className="flex flex-col items-start max-w-md px-6">
        <img
          src="/images/branding/assembly-logo-icon-white-on-black.svg"
          alt="Assembly"
          className="w-12 h-12 rounded-lg mb-6"
        />

        <BaseTypography fontType="24Medium" style={{ color: BlackHeadings }}>
          Your demo portal is ready
        </BaseTypography>

        <BaseTypography
          fontType="15Regular"
          style={{ color: GraySmall, marginTop: 12 }}
        >
          See exactly what your clients will experience — sign up as a test
          client on the next page to explore a live portal.
        </BaseTypography>

        <div className="mt-8">
          <Button variant="contained" color="primary" onClick={onContinue}>
            Create test client & explore
          </Button>
        </div>
      </div>
    </div>
  );
};
